import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FHeart from '~/js/components/heart'
import FLinkCard from '~/js/components/linkCard'
import FProductCard from '~/js/components/productCard'
import FTab from '~/js/components/tab'
import { LinkItem } from '~/js/models/linkItem'
import { TabItem } from '~/js/models/tabItem'
import {
  getProductsWithHashtag,
  getProductsByHandles,
} from '~/js/helpers/getProducts'
import { getUrlWithQueryParams } from '~/js/helpers/url-helper'
import { isDesktop } from '~/js/templates/index/helpers'
import { ProductListService } from '~/js/services/productListService'
const ID = 'js-customersAccountFavorites'
const TAB_ITEM_TITLES = [
  'アイテム',
  'コーディネート',
  'かわいい暮らしのヒント',
  'ハッシュタグ',
]
const PRODUCTS_PER_PAGE = 18

document.addEventListener('DOMContentLoaded', async () => {
  const element = document.getElementById(ID)
  if (!element) return

  const productListService = new ProductListService()
  const { hasError, wishlists } = await productListService.getWishLists()
  const wishlistId = wishlists.length ? wishlists[0].id : ''
  const wishlistProductIds = wishlists.length ? wishlists[0].productIds : []
  const search = new URLSearchParams(location.search)
  const tabParam = search.get('tab')
  const index = TAB_ITEM_TITLES.indexOf(tabParam)
  const selectedIndex = index > -1 ? index : 0
  if (!selectedIndex) {
    const url = new URL(window.location.origin + window.location.pathname)
    url.searchParams.set('view', 'favorites')
    history.replaceState(
      { tab: TAB_ITEM_TITLES[selectedIndex] },
      '',
      url.toString()
    )
  }

  const tabItems = TAB_ITEM_TITLES.map((title, index) => {
    const isSelected = index === selectedIndex
    return new TabItem({ title, isSelected })
  })
  const handles = element.dataset.favoriteProductHandles
    .split(',')
    .filter((handle) => handle)
    .reverse()
  const hashtags = element.dataset.favoriteHashtags
    .split(',')
    .filter((v) => v && !/{.*}/.test(v))
    .reverse()
    .map((hashtag) => {
      return {
        hashtag,
        isFavorite: true,
        isFetchingProducts: true,
        hasError: false,
      }
    })
  const productsWithHashtag = {}
  hashtags.forEach((hashtag) => {
    productsWithHashtag[hashtag.hashtag] = []
  })

  const linkItems = JSON.parse(element.dataset.linkItems)
    .map((linkItem) => {
      if (!linkItem.title) return null
      const url = `/blogs/coordinate/${linkItem.handle}`
      return new LinkItem(linkItem, url, true)
    })
    .filter((v) => v)

  const linkItemsArticle = JSON.parse(element.dataset.linkItemsArticle)
    .map((linkItemArticle) => {
      if (!linkItemArticle.title) return null
      const url = `/blogs/article/${linkItemArticle.handle}`
      return new LinkItem(linkItemArticle, url, true)
    })
    .filter((v) => v)

  createApp({
    name: 'TemplatesCustomersAccountFavorites',
    components: {
      FButton,
      FHeart,
      FLinkCard,
      FProductCard,
      FTab,
    },
    data() {
      return {
        allProducts: [],
        hasFetchError: false,
        hasLoadedAllProducts: false,
        showProductListButton: !hasError,
        handles,
        hashtags,
        isProcessing: false,
        linkItems,
        linkItemsArticle,
        products: [],
        productsWithHashtag: {},
        selectedIndex,
        tabItems,
        wishlistId,
        wishlistProductIds,
      }
    },
    computed: {
      canLoadMore() {
        if (this.hasFetchError) return false
        if (!this.hasLoadedAllProducts) return true
        return this.allProducts.length > this.products.length
      },
    },
    async created() {
      await this.getProducts()
      await this.getProductsWithHashtag()
    },
    methods: {
      isInWishlist(product) {
        return this.wishlistProductIds.includes(product.id)
      },
      onProductAddedToList(id) {
        this.wishlistProductIds.push(id)
      },
      onProductRemovedFromList(id) {
        const index = this.wishlistProductIds.findIndex(
          (productId) => productId === id
        )
        if (index === -1) return
        this.wishlistProductIds.splice(index, 1)
      },
      async fetchProducts() {
        if (!this.handles.length) return []
        try {
          return await getProductsByHandles(this.handles)
        } catch (error) {
          this.hasFetchError = true
          return []
        }
      },
      async getProducts() {
        if (this.isProcessing || !this.canLoadMore) return
        this.isProcessing = true

        try {
          if (!this.allProducts.length) {
            const fetchedProducts = await this.fetchProducts()
            if (this.hasFetchError) {
              this.hasLoadedAllProducts = false
              return
            }

            this.allProducts = fetchedProducts
            this.hasLoadedAllProducts = true
          }

          const nextProducts = this.allProducts.slice(
            this.products.length,
            this.products.length + PRODUCTS_PER_PAGE
          )

          this.products = [...this.products, ...nextProducts]
        } catch (e) {
          console.error('Failed to get favorite products for display:', e)
          this.hasFetchError = true
        } finally {
          this.isProcessing = false
        }
      },

      async getProductsWithHashtag() {
        this.hashtags.forEach(async (hashtag) => {
          try {
            const products = await getProductsWithHashtag(hashtag.hashtag)
            const count = isDesktop() ? 3 : 4
            this.productsWithHashtag[hashtag.hashtag] = products.slice(0, count)
          } catch {
            hashtag.hasError = true
          }
          hashtag.isFetchingProducts = false
        })
      },

      onHeartChanged(isFavorite, index) {
        this.hashtags[index].isFavorite = isFavorite
      },

      onTabSelected(index) {
        this.selectedIndex = index
        this.tabItems.forEach(
          (tabItem, i) => (tabItem.isSelected = i === index)
        )
        const state = { tab: TAB_ITEM_TITLES[index] }
        const url = getUrlWithQueryParams({ tab: TAB_ITEM_TITLES[index] })
        history.pushState(state, '', url)
      },
    },
  }).mount(element)
})
